export default {
  C: "C",
  CSharp: "C♯",
  D: "D",
  DFlat: "D♭",
  DSharp: "D♯",
  E: "E",
  EFlat: "E♭",
  F: "F",
  FSharp: "F♯",
  G: "G",
  GFlat: "G♭",
  GSharp: "G♯",
  A: "A",
  AFlat: "A♭",
  ASharp: "A♯",
  B: "B",
  BFlat: "B♭",

  correctExcl: "Correct!",
  wrongExcl: "Wrong!",

  ABORT: "ABORT",

  lastRound: "Last Round",
  score: "Score",
  accuracy: "Accuracy",
  correct: "correct",
  wrong: "wrong",

  START: "START",
  settings: "Settings",
  ROUND_LENGTH: "ROUND LENGTH",
  NOTE_INPUT: "NOTE INPUT",
  CLEF: "CLEF",
  DIFFICULTY: "DIFFICULTY",
  ACCIDENTALS: "ACCIDENTALS",
  LANGUAGE: "LANGUAGE",
  twentySeconds: "20 s",
  oneMinute: "1 min",
  fiveMinutes: "5 min",
  infinite: "Infinite",
  buttons: "Buttons",
  piano: "Piano",
  trebleClef: "Treble",
  bassClef: "Bass",
  altoClef: "Alto",
  tenorClef: "Tenor",
  easy: "Easy",
  normal: "Normal",
  hard: "Hard",
  none: "None",
  sharp: "♯",
  flat: "♭",
  sharpAndFlat: "♯ and ♭",
  SOUND: "SOUND",
  VIBRATION: "VIBRATION",
  DISPLAYCORRECTNOTE: "DISPLAY CORRECT NOTE",
  on: "On",
  off: "Off",

  TIME: "TIME",
  CORRECT: "CORRECT",
  ACCURACY: "ACCURACY",
  SCORE: "SCORE",

  record: "High Score",
  history: "History",

  noMidiSupport: "Sorry, it seems as if your device does not support MIDI.",
  noDeviceFound: "No device found. Please reconnect the MIDI device.",
  playTheNote: "Play the note on your MIDI keyboard.",
  lastNotePlayed: "Last note played",
};



// WEBPACK FOOTER //
// ./src/resources/en.js